import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useEffect,
  useState,
} from "react"
import { useDaySelector } from "../useDaySelector"
import { useFollowedUsers } from "src/contexts"
import { useEventsAndSubEntriesOfType } from "src/hooks"

export function useAverageGlucoseDayMetric(dayStart: string) {
  const daySelector = useDaySelector(dayStart)
  const { currentFollow } = useFollowedUsers()

  const [
    averageReading,
    setAverageReading,
  ] = useState<number>(NaN)

  const {
    isFetchingEvents,
    isFetchingEntries,
    events: glucoseEvents,
    subEntries: glucoseSubEntries,
  } = useEventsAndSubEntriesOfType(
    currentFollow.following_account_id,
    ActivityType.Glucose,
    daySelector,
  )

  useEffect(
    () => {
      if (isFetchingEntries || isFetchingEvents) {
        return
      }

      let sum = 0

      const totalReadings = glucoseEvents.length + glucoseSubEntries.length

      if (totalReadings === 0) {
        setAverageReading(NaN)
        return
      }

      glucoseEvents.forEach(
        (glucoseEvent) => {
          sum += glucoseEvent.glucose.mg_dl
        },
      )

      glucoseSubEntries.forEach(
        (subEntry) => {
          sum += subEntry.glucose.mg_dl
        },
      )

      setAverageReading(sum / totalReadings)
    },
    [
      isFetchingEntries,
      isFetchingEvents,
      setAverageReading,
      glucoseEvents,
      glucoseSubEntries,
    ],
  )

  return averageReading
}
